import colors from '../tokens/colors';

export const accordionGetolo = {
  borderRadius: '4px',
  errorBorder: '1px solid',
  highlightBorder: '2px solid',
  highlightBorderColor: colors.PROFESSIONAL_BLUE,
  highlightMediumBorder: `1px solid ${colors.PROFESSIONAL_LIGHT_BLUE}`,
  padding: '1rem',
  margin: 'auto auto 1rem',
  outline: {
    size: '3px solid',
    color: 'transparent',
    offset: 3,
  },
  header: {
    icon: {
      width: {
        sm: '2rem',
      },
      height: {
        sm: '2rem',
      },
    },
    minHeight: {
      sm: '4.5rem',
    },
    padding: {
      sm: '1rem',
    },
    typography: {
      title: 'h3',
      subtitle: 'body',
    },
  },
  body: {
    padding: {
      sm: '0.5rem 1rem 1.5rem',
    },
    typography: 'body',
  },
  states: {
    focusVisible: {
      outlineColor: colors.PROFESSIONAL_BLUE,
    },
  },
};

export const accordionDaDirekt = {
  borderRadius: '4px',
  errorBorder: '1px solid',
  highlightBorder: '2px solid',
  highlightBorderColor: colors.PROFESSIONAL_BLUE,
  highlightMediumBorder: `1px solid ${colors.PRODUCT_BLUE}`,
  padding: '1rem',
  margin: 'auto auto 1rem',
  outline: {
    size: '2px solid',
    color: 'transparent',
    offset: 2,
  },
  header: {
    icon: {
      width: {
        sm: '2rem',
      },
      height: {
        sm: '2rem',
      },
    },
    minHeight: {
      sm: '4.625rem',
    },
    padding: {
      sm: '1rem',
    },
    typography: {
      title: 'h3',
      subtitle: 'body',
    },
  },
  body: {
    padding: {
      sm: '0.5rem 1rem 1.5rem',
    },
    typography: 'body',
  },
  states: {
    focusVisible: {
      outlineColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
  },
};

export const accordionDaKaufland = {
  borderRadius: 0,
  errorBorder: '1px solid',
  highlightBorder: 'none',
  highlightBorderColor: 'transparent',
  highlightMediumBorder: 'transparent',
  padding: '0.625rem',
  margin: 'auto auto 2.75rem',
  outline: {
    size: '2px solid',
    color: 'transparent',
    offset: 2,
  },
  header: {
    icon: {
      width: {
        sm: '2.75rem',
      },
      height: {
        sm: '2.75rem',
      },
    },
    minHeight: {
      sm: '4.125rem',
    },
    padding: {
      sm: '0.625rem 0.625rem 0.625rem 0',
    },
    typography: {
      title: 'h4',
      subtitle: 'p4',
    },
  },
  body: {
    padding: {
      sm: '1rem 0 1.5rem',
    },
    typography: 'p4',
  },
  states: {
    focusVisible: {
      outlineColor: colors.DA_KAUFLAND_RED,
    },
  },
};

export const accordionFressnapf = {
  borderRadius: '4px',
  errorBorder: '1px solid',
  highlightBorder: '2px solid',
  highlightBorderColor: colors.COLOR_LIGHT_ORANGE,
  highlightMediumBorder: `1px solid ${colors.COLOR_LIGHT_ORANGE}`,
  padding: '1rem',
  margin: 'auto auto 1rem',
  outline: {
    size: 'none',
    color: 'transparent',
    offset: 0,
  },
  header: {
    icon: {
      width: {
        sm: '2rem',
      },
      height: {
        sm: '2rem',
      },
    },
    minHeight: {
      sm: '4.625rem',
    },
    padding: {
      sm: '1rem',
    },
    typography: {
      title: 'h3',
      subtitle: 'p',
    },
  },
  body: {
    padding: {
      sm: '0.5rem 1rem 1.5rem',
    },
    typography: 'body',
  },
  states: {
    focusVisible: {
      outlineColor: 'transparent',
    },
  },
};
